/**
 * Fetch/XHR cancelled on purpose (hls.js stopLoad/destroy, IntersectionObserver
 * evict, AbortController). The SDK reports it as "Fetch error" with status 0,
 * but it is not a failure: ~98% of those logs on HLS.
 */
export function isAbortedNetworkLog(
	log: { origin?: string },
	context: unknown
): boolean {
	return (
		log.origin === 'network' &&
		Boolean((context as { isAborted?: boolean } | undefined)?.isAborted)
	);
}
